import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

export default function CampaignPausedTooltip({
  children,
  isEditingDisabled,
}: {
  children: JSX.Element;
  isEditingDisabled: boolean;
}) {
  if (isEditingDisabled) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent>Campaign must be paused to make changes</TooltipContent>
      </Tooltip>
    );
  }
  return children;
}
